import dayjs from 'dayjs';
import _ from 'lodash';
import { SearchStatus, FiltersInitialValue, TravelTypes, LocationTypes } from '../../../constants';
import formatTabLabel from './formatTabLabel';

const formatSearchObj = (travelOption, cars, isCarSearchExist, trip, cruiseItineraryId) => {
  let tabs = isCarSearchExist
    ? Object.values(cars.carTabs)
    : [
        {
          label: 'New segment',
          value: 0,
          searchStatus: SearchStatus.INITIAL,
          searchObj: FiltersInitialValue.car,
        },
      ];
  if (
    !tabs[0].searchObj.dropoffCode ||
    Object.values((trip || {}).rentalCarItineraries || {}).length === 0
  ) {
    let flightItinerary =
      travelOption && travelOption.mode === TravelTypes.flight && travelOption.flightItinerary;
    if (!flightItinerary && trip && trip.flightItinerary) flightItinerary = trip.flightItinerary;

    let hotelItinerary =
      travelOption && travelOption.mode === TravelTypes.hotel && travelOption.hotelItinerary;
    if (
      !hotelItinerary &&
      trip &&
      trip.hotelItineraries &&
      Object.keys(trip.hotelItineraries).length > 0 &&
      trip.hotelItineraries[0]
      // oxlint-disable-next-line prefer-destructuring
    )
      hotelItinerary = trip.hotelItineraries[0];

    if (flightItinerary) {
      const pickup = flightItinerary.flightSegments[0].destinationGeoname;
      const dropoff = flightItinerary.flightSegments[1]
        ? flightItinerary.flightSegments[1].originGeoname
        : pickup;
      const pickupDT = flightItinerary.flightSegments[0].arrivalDateTime;
      let returnDT = flightItinerary.flightSegments[1]
        ? flightItinerary.flightSegments[1].departureDateTime
        : undefined;

      if (!returnDT && pickupDT) {
        returnDT = dayjs(pickupDT).add(1, 'day').format('YYYY-MM-DDTHH:mm:ss');
      }

      tabs = {
        ...tabs,
        0: {
          ...tabs[0],
          label: formatTabLabel(pickup.iata, dropoff.iata, pickupDT, returnDT),
          searchObj: {
            ...tabs[0].searchObj,
            pickupDateTime: pickupDT,
            returnDateTime: returnDT,
            dropoffCode: {
              ...pickup,
              label: pickup.name,
              airportCode: pickup.iata,
              value: pickup.id,
            },
            pickupCode: {
              ...dropoff,
              label: dropoff.name,
              airportCode: dropoff.iata,
              value: dropoff.id,
            },
          },
        },
      };
    } else if (hotelItinerary) {
      const pickupDT = hotelItinerary.hotel.checkInStartTime.replace('T00:00:00', 'T10:00:00');
      const returnDT = hotelItinerary.hotel.checkOutEndTime.replace('T00:00:00', 'T11:00:00');
      const location = hotelItinerary.searchGeoname && {
        ...hotelItinerary.searchGeoname,
        label: hotelItinerary.searchGeoname.name,
        value:
          hotelItinerary.searchGeoname.googlePlaceId ||
          hotelItinerary.searchGeoname.departureCityId,
        locationType:
          hotelItinerary.searchGeoname.departureCityId > 0
            ? LocationTypes.PORT_OF_DEPARTURE
            : undefined,
      };
      tabs = {
        ...tabs,
        0: {
          ...tabs[0],
          label: hotelItinerary.searchGeoname
            ? formatTabLabel(
                hotelItinerary.searchGeoname.name,
                hotelItinerary.searchGeoname.name,
                pickupDT,
                returnDT,
              )
            : 'New segment',
          searchObj: {
            ...tabs[0].searchObj,
            pickupDateTime: pickupDT,
            returnDateTime: returnDT,
            dropoffCode: location,
            pickupCode: location,
          },
        },
      };
    } else if (
      travelOption &&
      travelOption.mode === TravelTypes.cruise &&
      travelOption.itineraryRows
    ) {
      let index = 0;
      if (cruiseItineraryId) {
        index = _.findIndex(travelOption.itineraryRows, (r) => r.itineraryId === cruiseItineraryId);
      }
      if (index === -1) index = 0;
      const pickupDT = dayjs(travelOption.itineraryRows[index].itineraryDepartDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DDT00:00:00')
        .replace('T00:00:00', 'T10:00:00');
      const returnDT = travelOption.itineraryRows[index].itineraryDepartDate.replace(
        'T00:00:00',
        'T10:00:00',
      );
      const location = {
        label: travelOption.itineraryDepartCity,
        value: travelOption.itineraryDepartCityId,
        locationType: LocationTypes.PORT_OF_DEPARTURE,
      };
      tabs = {
        ...tabs,
        0: {
          ...tabs[0],
          label: formatTabLabel(
            travelOption.itineraryDepartCity,
            travelOption.itineraryDepartCity,
            pickupDT,
            returnDT,
          ),
          searchObj: {
            ...tabs[0].searchObj,
            pickupDateTime: pickupDT,
            returnDateTime: returnDT,
            dropoffCode: location,
            pickupCode: location,
          },
        },
      };
    }
  }
  return tabs;
};
export default formatSearchObj;
